/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/ModifyPageOptions.yaml
import { ParametricFilter } from '../core/image_processing/ParametricFilters';
/**
Options for modifying a page within a document.
*/
export class ModifyPageOptions {
    /** @param source {@displayType `DeepPartial<ModifyPageOptions>`} */
    constructor(source = {}) {
        /**
          The type of rotation to apply.
          
          Default is NONE
          */
        this.rotation = 'NONE';
        /**
          The polygon to which the page will be cropped. If not specified, no cropping is applied.
          */
        this.polygon = null;
        /**
          The list of filters applied to the page. If not specified, no filters are applied.
          */
        this.filters = null;
        if (source.rotation !== undefined) {
            this.rotation = source.rotation;
        }
        if (source.polygon !== undefined) {
            this.polygon =
                source.polygon != null
                    ? source.polygon.map((it) => {
                        return { x: it.x, y: it.y };
                    })
                    : null;
        }
        if (source.filters !== undefined) {
            this.filters =
                source.filters != null
                    ? source.filters.map((it) => {
                        return ParametricFilter.from(it);
                    })
                    : null;
        }
    }
}
//# sourceMappingURL=ModifyPageOptions.js.map